import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HOCform from '../../hocs/form/index';

class Form extends Component {
  static propTypes = {
    getValues: PropTypes.func,
    resetForm: PropTypes.func,
    resetField: PropTypes.func,
    validate: PropTypes.func,
    validateAll: PropTypes.func,
    showError: PropTypes.func,
    hideError: PropTypes.func
  };

  componentWillReceiveProps() {
    this.forceUpdate();
  }

  render() {

    const { ...props } = this.props;

    return (
      <form {...props} />
    );
  }
}

export default HOCform(Form);



// WEBPACK FOOTER //
// ./src/components/react-validation/components/form/index.js